import React from "react";
import "../styles/AlertMessage.css"; // Pastikan ada fail CSS

const AlertMessage = ({ message, isVisible }) => {
    return (
        <div className={`alert-message ${isVisible ? "show" : ""}`}>
            {message}
        </div>
    );
};

export default AlertMessage;
